import { Button, Form, Input, notification, Typography, Space } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import FormItem from 'antd/lib/form/FormItem';
import React, { useState } from 'react';
import { UserOutlined, LockOutlined, LoginOutlined } from '@ant-design/icons';
import { ACCESS_TOKEN, REFRESH_TOKEN } from '../../../utils/constants';
import { rutValidator } from '../../../utils/formValidator';
import './LoginForm.scss';
import { handleApiError } from 'utils/handlers';
import { postToApi } from 'api/axios';
import { consumeReturnUrl } from 'utils/returnUrl';

// const signInUser = async (data, isFinish) =>
//   handleApiResponse(
//     postToApi,
//     `/user/sign-in`,
//     data,
//     'Error del servidor: No ha enviado respuesta.',
//     isFinish
//   );

function LoginForm() {
  const [form] = useForm();
  const [loading, setLoading] = useState(false);

  const finishForm = async () => {
    const values = form.getFieldsValue();
    setLoading(true);
    try {
      const loginResponse = await postToApi('/user/sign-in', values);
      const { data } = loginResponse;
      // form.resetFields();
      const { accessToken, refreshToken } = data;
      if (!accessToken || !refreshToken) {
        throw new Error('Error del servidor, no se han enviado las credenciales de sesión');
      }
      localStorage.setItem(ACCESS_TOKEN, accessToken);
      localStorage.setItem(REFRESH_TOKEN, refreshToken);

      notification.success({
        message: '¡Bienvenido!',
        description: 'Has iniciado sesión correctamente.',
        placement: 'topRight',
      });

      // Si el usuario llegó por un deep-link (ej. link del correo de cita),
      // volver a ese destino; si no, a la home.
      const returnUrl = consumeReturnUrl();
      window.location.href = returnUrl ? `/#${returnUrl}` : '/';
    } catch (error) {
      if (error?.response) {
        notification.error({
          message: 'Error de autenticación',
          // `mensaje` primero: los endpoints con código de negocio (ej. el 429 del límite
          // de intentos) responden `{code, mensaje}`. Sin esto, a quien se quedó sin
          // intentos se le decía "Credenciales incorrectas" y seguía probando.
          description:
            error?.response?.data?.mensaje ||
            error?.response?.data?.message ||
            'Credenciales incorrectas',
          placement: 'topRight',
        });
      } else {
        handleApiError(error);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-form-container">
      <Form
        form={form}
        className="login-form form"
        onFinish={finishForm}
        layout="vertical"
        size="large"
      >
        <Space direction="vertical" size="large" className="w-full">
          <Form.Item
            name="rut"
            label={
              <span className="text-gray-700 font-medium">
                <UserOutlined className="mr-2" />
                RUT
              </span>
            }
            rules={[
              { required: true, message: 'Debe ingresar su RUT' },
              {
                validator: (_, value) =>
                  rutValidator(value)
                    ? Promise.resolve()
                    : Promise.reject(new Error('El RUT ingresado no es válido')),
              },
              {
                max: 12,
                min: 0,
                message: 'Este campo no puede tener más de 12 caracteres',
              },
            ]}
          >
            <Input
              placeholder="12.345.678-9"
              className="rounded-lg"
              prefix={<UserOutlined className="text-gray-400" />}
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="password"
            label={
              <span className="text-gray-700 font-medium">
                <LockOutlined className="mr-2" />
                Contraseña
              </span>
            }
            rules={[
              { required: true, message: 'Debe ingresar su contraseña' },
              {
                max: 40,
                min: 0,
                message: 'Este campo no puede tener más de 45 caracteres',
              },
            ]}
          >
            <Input.Password
              placeholder="Ingrese su contraseña"
              className="rounded-lg"
              prefix={<LockOutlined className="text-gray-400" />}
              size="large"
            />
          </Form.Item>

          <FormItem className="mt-6">
            <Button
              htmlType="submit"
              type="primary"
              block
              loading={loading}
              size="large"
              icon={<LoginOutlined />}
              className="login-button h-12 text-base font-medium rounded-lg"
            >
              {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
            </Button>
          </FormItem>
        </Space>
      </Form>

      <div className="login-footer mt-6 text-center">
        <Typography.Text type="secondary" className="text-sm">
          ¿Problemas para acceder?{' '}
          <Typography.Link className="text-blue-600 hover:text-blue-700">
            Contacta al administrador
          </Typography.Link>
        </Typography.Text>
      </div>
    </div>
  );
}

export default LoginForm;
